<template>
    <div class="md-layout">
        <staff-list></staff-list>
    </div>
</template>
<script>
import staffList from "../../components/Staff/staffList";

export default {
    components: {
        staffList
    }
};
</script>
